import { Colors } from './uiColors'
import { hexToRGB, rgbToHex } from '../utils/colorUtils'

export type StatusSurfaceType =
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'primary'

export type StatusSurfaceStyleConfig = {
  borderAccent: string
  gradientStart: string
  gradientStartAlpha: number
  gradientEnd: string
  gradientEndAlpha: number
  iconColor: string
}

export const STATUS_SURFACE_STYLES: Record<
  StatusSurfaceType,
  StatusSurfaceStyleConfig
> = {
  success: {
    borderAccent: Colors.green500,
    gradientStart: Colors.green500,
    gradientStartAlpha: 0.18,
    gradientEnd: Colors.green400,
    gradientEndAlpha: 0.1,
    iconColor: Colors.success,
  },
  info: {
    borderAccent: Colors.blue500,
    gradientStart: Colors.blue500,
    gradientStartAlpha: 0.18,
    gradientEnd: Colors.info,
    gradientEndAlpha: 0.1,
    iconColor: Colors.info,
  },
  warning: {
    borderAccent: Colors.orange500,
    gradientStart: Colors.orange500,
    gradientStartAlpha: 0.18,
    gradientEnd: Colors.yellow500,
    gradientEndAlpha: 0.1,
    iconColor: Colors.warning,
  },
  danger: {
    borderAccent: Colors.red500,
    gradientStart: Colors.red500,
    gradientStartAlpha: 0.18,
    gradientEnd: Colors.danger,
    gradientEndAlpha: 0.1,
    iconColor: Colors.danger,
  },
  primary: {
    borderAccent: Colors.brandPrimary,
    gradientStart: Colors.brandPrimary,
    gradientStartAlpha: 0.18,
    gradientEnd: Colors.purple400,
    gradientEndAlpha: 0.1,
    iconColor: Colors.brandPrimary,
  },
}

export function withAlpha(hex: string, alpha: number): string {
  const { red, green, blue } = hexToRGB(hex)
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`
}

export function mixSRGB(
  color1: string,
  color2: string,
  color1Weight: number
): string {
  const a = hexToRGB(color1)
  const b = hexToRGB(color2)
  const w = Math.max(0, Math.min(1, color1Weight))
  return rgbToHex({
    red: Math.round(a.red * w + b.red * (1 - w)),
    green: Math.round(a.green * w + b.green * (1 - w)),
    blue: Math.round(a.blue * w + b.blue * (1 - w)),
  })
}

export function getStatusSurfaceBorderColor(
  accentColor: string,
  borderColor: string
): string {
  return mixSRGB(accentColor, borderColor, 0.32)
}

export function getStatusSurfaceGradientColors(
  config: StatusSurfaceStyleConfig
): [string, string] {
  return [
    withAlpha(config.gradientStart, config.gradientStartAlpha),
    withAlpha(config.gradientEnd, config.gradientEndAlpha),
  ]
}
